import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as EditIcon } from '../../../assets/img/edit.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/img/delete.svg';
import { ReactComponent as MoreIcon } from '../../../assets/img/More-V.svg';

const AssetActionsMenu = ({ asset, onDelete, onEdit, isUp, isFirst }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <span className="actions-menu-wrapper" ref={menuRef}>
      <span className="actions-ellipsis" onClick={() => setOpen((v) => !v)}>
        <MoreIcon />
      </span>
      {open && (
        <div className={`actions-menu ${isUp ? 'actions-menu--up' : ''} ${isFirst ? 'actions-menu--first' : ''}`}>
          <button
            className="actions-menu-button"
            onClick={() => {
              onEdit(asset);
              setOpen(false);
            }}
          >
            <EditIcon className="actions-menu-icon" /> Edit
          </button>
          <button
            className="actions-menu-button actions-menu-delete"
            onClick={() => {
              onDelete(asset);
              setOpen(false);
            }}
          >
            <DeleteIcon className="actions-menu-icon" /> Delete
          </button>
        </div>
      )}
    </span>
  );
};

export default AssetActionsMenu;
